<template>
  <carousel
    :items-to-show="1"
    :wrap-around="true"
    :transition="1000"
    class="h-full w-full"
  >
    <slide
      v-for="slide in items"
      :key="slide.id"
      class="w-full flex items-center justify-center "
    >
      <!-- Background image -->
      <img
        :src="slide.imageUrl"
        alt="Slide Image"
        class="w-full h-[240px] md:h-[540px] 2xl:h-[520px] object-cover"
      />

      <!-- Gradient overlay -->
      <div class="absolute inset-0 bg-gradient-to-r from-[#6f6117]/80 to-transparent z-10"></div>

      <!-- Text content -->
      <div class="absolute top-[20%] left-0 w-full flex flex-col items-center z-20">
        <div class="w-[94%] md:w-[84%]">
          <h3 class="text-[#F6E271] text-xl">{{ slide.name }}</h3>
          <h1 class="text-xl md:text-5xl pt-3 font-semibold text-white">{{ slide.title }}</h1>
          <p class="pt-3 text-white md:w-[40%] font-semibold">{{ slide.description }}</p>
        </div>
      </div>
    </slide>

    <!-- Optional pagination/navigation if needed -->
    <template #addons>
      <navigation  />
      <Pagination class="hidden" />
    </template>
  </carousel>
</template>

<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import { db } from "@/firebaseConfig";
import { collection, getDocs } from "firebase/firestore";

export default {
  name: "HomeBanner",
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.fetchBanners();
  },
  methods: {
    async fetchBanners() {
      const snapshot = await getDocs(collection(db, "homeBanner"));
      this.items = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    },
  },
};
</script>

<style scoped>
.carousel__pagination {
  position: absolute;
  bottom: 36px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
}
</style>
